<template>
	<v-stepper elevation="0" class="container-stepper-claro" non-linear v-model="passoAtual">
		<v-stepper-header elevation="0" class="stepper-ata">
			<div v-for="step in steps" :key="step.num">
				<v-stepper-step :complete="passoAtual > step.num" :editable="isEditable" :step="step.num"
					>{{ step.nome }}
				</v-stepper-step>
				<v-divider v-if="!ehUltimoStep(step.num)"></v-divider>
			</div>
		</v-stepper-header>
		<v-divider></v-divider>
		<v-stepper-items>
			<v-stepper-content :step="step.num" v-for="step in steps" :key="step.num">
				<slot :name="`step-${step.num}`"></slot>
			</v-stepper-content>
		</v-stepper-items>
	</v-stepper>
</template>
<script>
export default {
	name: 'stepper-tema-claro',
	props: {
		steps: {
			type: Array,
			required: true,
		},
		stepAtual: {
			type: Number,
			default: 1,
		},
		editable: {
			type: Boolean,
		},
	},
	computed: {
		passoAtual: {
			get() {
				return this.stepAtual
			},
			set(passoAtual) {
				this.$emit('step-alterado', passoAtual)
			},
		},
		isEditable() {
			return this.editable
		},
	},
	methods: {
		ehUltimoStep(step) {
			return step === this.steps.length
		},
	},
}
</script>
<style lang="stylus" scoped>
.container-stepper-claro
	.stepper-ata
		margin auto

		.v-divider
			width 100px
			margin auto

		div
			display flex
			flex-direction revert
			align-content center
			align-items center


	.v-stepper__header
		margin auto
		box-shadow none
		justify-content center

	.v-stepper__content
		padding 0 !important
</style>
